export function FlushAll() {
  let count = 0;

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.includes(":::cache")) {
      localStorage.removeItem(key);
      count++;
    }
  }
  console.log(count + " old cache flushed!");
}
